
import { configureStore } from "@reduxjs/toolkit";
import { stateSlice } from "./stateSlice";
import storage from "redux-persist/lib/storage"; 
import { persistReducer, persistStore } from "redux-persist";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, stateSlice.reducer);

export const store = configureStore({
  reducer: {
    reduxState: persistedReducer,
  },
});

export const persistor = persistStore(store);
